import { useMediaQuery } from 'react-responsive'
import { Mask } from '../../../../hooks/Mask'
import { breakpoints } from '../../../../MediasQueries'
import Component from '../../Component'
import InputComponent from '../../Input'
import Base from '../index'
import { Adicional, AdicionalItem, Components, Half, Item, ModalDivInput } from './style'

const ModalInfoProduct = ({ prod }) => {
  const isSoSmall = useMediaQuery({ maxWidth: breakpoints.xs })
  const {
    nome,
    id_contexto,
    preco_venda_unit,
    preco_venda,
    preco_custo_unit,
    preco_custo,
    plataformas,
    lucro,
    quantidade,
    unidade,
    componentes,
    codigo_barras,
  } = prod

  const { preco_zero } = plataformas[0]
  return (
    <Base title={'Detalhes completos'} width={'60%'} height={isSoSmall ? '500px' : 'auto'}>
      <ModalDivInput>
        <Half>
          <InputComponent height={'36px'} value={id_contexto} label={'Id'} view></InputComponent>
          <InputComponent height={'36px'} value={nome} label={'Nome'} view></InputComponent>
        </Half>
        <InputComponent
          height={'36px'}
          value={Mask.money(preco_custo)}
          label={'Custo total'}
          view
        ></InputComponent>
        <InputComponent
          height={'36px'}
          value={Mask.money(preco_custo_unit)}
          label={'Custo por produto'}
          view
        ></InputComponent>

        <InputComponent
          height={'36px'}
          label={'Lucro'}
          value={Mask.percent(lucro)}
          view
        ></InputComponent>
        <InputComponent
          height={'36px'}
          value={Mask.money(preco_zero)}
          label={'Preço Zero (Balcão)'}
          view
        ></InputComponent>

        <InputComponent
          height={'36px'}
          value={Mask.money(preco_venda)}
          label={'Preço base total'}
          view
        ></InputComponent>
        <InputComponent
          height={'36px'}
          value={Mask.money(preco_venda_unit)}
          label={'Preço base por produto'}
          view
        ></InputComponent>

        <InputComponent
          height={'36px'}
          value={Mask.money(preco_venda - preco_custo)}
          label={'Margem de contribuição total'}
          view
        ></InputComponent>

        <InputComponent
          height={'36px'}
          value={Mask.money(preco_venda_unit - preco_custo_unit)}
          label={'Margem de contribuição por produto'}
          view
        ></InputComponent>

        <Adicional>
          <label>Adicionais (Qtd/Uni)</label>
          <AdicionalItem>
            <span>
              {quantidade} {unidade}
            </span>
          </AdicionalItem>
        </Adicional>
        <Item>
          {codigo_barras && (
            <InputComponent
              height={'36px'}
              value={codigo_barras}
              label={'Código de barras'}
              view
            ></InputComponent>
          )}
          {componentes.length > 0 && <label>Componentes</label>}
          <Components>
            {componentes?.map((item) => {
              return (
                <Component
                  id={item.id}
                  key={item.id}
                  title={item.nome}
                  quantidade={item.quantidade}
                  unidade={item.unidade}
                />
              )
            })}
          </Components>
        </Item>
      </ModalDivInput>
    </Base>
  )
}
export default ModalInfoProduct
